export const en = {
    "download-more": "Download more",
    "header": "User ratings",
    "no-feedback": "Unfortunately, no one has left a review yet",
    "table-date": "Date",
    "table-feedback": "Feedback",
    "table-rating": "Rating"
} as const;
export const ru = {
    "download-more": "Загрузить ещё",
    "header": "Оценки пользователей",
    "no-feedback": "К сожалению, пока еще никто не оставил отзыв",
    "table-date": "Дата",
    "table-feedback": "Отзыв",
    "table-rating": "Оценка"
} as const;